import React from 'react';
import { LayersIcon, SearchCheckIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { benefits } from '../data/site';
import { BrandGlyph } from './BrandGlyph';
import { Reveal } from './Reveal';
const icons = {
  users: UsersIcon,
  shield: ShieldCheckIcon,
  search: SearchCheckIcon,
  layers: LayersIcon
};
export function WhyCoPro() {
  return <section id="why-copro" aria-labelledby="why-heading" className="relative isolate overflow-hidden bg-charcoal-900 py-20 lg:py-28" data-id="element-269" data-mp="1tb4izn16maze">
      <BrandGlyph className="pointer-events-none absolute -right-10 top-8 hidden w-[520px] text-white/[0.045] lg:block" data-id="element-270" data-mp="2m0tfbn2y5muo" />

      <div className="relative mx-auto max-w-container px-5 lg:px-8" data-id="element-271" data-mp="27783upq616z7">
        <Reveal className="max-w-2xl" data-id="element-272" data-mp="2c2dt9yis13s1">
          <p className="text-[13px] font-bold uppercase tracking-[0.16em] text-cobalt-300" data-id="element-273" data-mp="vpozuv4rgzzl">
            Why CoPro
          </p>
          <h2 id="why-heading" className="mt-4 text-3xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-[2.75rem]" data-id="element-274" data-mp="10p1rdt6kuv8i">
            Why Businesses Choose CoPro
          </h2>
        </Reveal>

        <ul className="mt-14 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-275" data-mp="rqp2w99p0o9z">
          {benefits.map((benefit, index) => {
          const Icon = icons[benefit.icon];
          return <Reveal as="li" key={benefit.title} delay={index * 0.06} data-id="element-276" data-mp="10rn64pcb4rri" data-mpi={index}>
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-cobalt-700 text-white" aria-hidden="true" data-id="element-277" data-mp="1fli8dchyjitq">
                  <Icon className="h-6 w-6" strokeWidth={2} data-id="element-278" data-mp="1oe2341v4p39a" />
                </span>
                <h3 className="mt-6 text-lg font-bold tracking-tight text-white" data-id="element-279" data-mp="1kd9rx32p4oad">
                  {benefit.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-charcoal-300" data-id="element-280" data-mp="1ydkj677x44w2">
                  {benefit.description}
                </p>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}